"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JourneyNavbar = void 0;
var React = require("react");
var reactstrap_1 = require("reactstrap");
var StickyHelpButtonPopup_1 = require("../components/modals/StickyHelpButtonPopup");
var services_1 = require("@falcon/services");
var react_router_dom_1 = require("react-router-dom");
var JourneyNavbar = function (props) {
    var _a = React.useState(false), isOpen = _a[0], setIsOpen = _a[1];
    var toggle = function () { return setIsOpen(!isOpen); };
    return (React.createElement(reactstrap_1.Navbar, { className: "d-flex journey-header", expand: "md" },
        React.createElement("div", { className: "journey-header-background" },
            React.createElement(reactstrap_1.NavbarBrand, null,
                React.createElement("a", { className: "header-logo-link", id: "goToAllianzHomePage", href: "https://www.allianz.co.uk", target: "_blank" },
                    React.createElement("img", { className: "flow-logo", src: "/".concat(services_1.resourcesHelper.THEME, "/img/brand-logo.png"), alt: "".concat(services_1.resourcesHelper.THEME, " logo icon") }))),
            React.createElement(reactstrap_1.NavbarToggler, { onClick: toggle }),
            React.createElement(reactstrap_1.Collapse, { isOpen: isOpen, navbar: true },
                React.createElement(reactstrap_1.Nav, { className: "ml-auto flex-column-reverse flex-md-row pt-3 pt-md-0", navbar: true },
                    React.createElement(StickyHelpButtonPopup_1.StickyHelpButtonPopup, null,
                        React.createElement(reactstrap_1.NavItem, null,
                            React.createElement("span", { id: "help" }, "Help"))),
                    React.createElement(reactstrap_1.NavItem, null,
                        React.createElement("span", null,
                            React.createElement(react_router_dom_1.Link, { to: "#", className: "log-out-link", onClick: props.logout }, "Log out"))))))));
};
exports.JourneyNavbar = JourneyNavbar;
//# sourceMappingURL=JourneyNavbar.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/components/JourneyNavbar.js
// module id = 3481
// module chunks = 0